/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ContainerMenu } from '../../../components/Containers';
import { SearchLinksSystemsAction } from '../../../redux/actions/linksSystem';
import DevMod from './devMod';
import AdminSinc from './adminSinc';
import UserSinc from './userSinc';
import UserSpa from './userSpa';
import AdminSpa from './adminSpa';
import NewSystem from './newSystem';
import SuporteSinc from './suporteSinc';

export default function TemplateMenu() {
  const { userInfo } = useSelector((state) => state.userSign);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(SearchLinksSystemsAction());
  }, [dispatch]);

  return (
    <ContainerMenu>
      {userInfo === null ? (
        ''
      ) : userInfo.accessMode === process.env.REACT_APP_DEV_ACCESS ? (
        <DevMod />
      ) : userInfo.accessMode === process.env.REACT_APP_ADMIN_SINCRONIZA_ACCESS ? (
        <AdminSinc />
      ) : userInfo.accessMode === process.env.REACT_APP_USER_SINCRONIZA_ACCESS ? (
        <UserSinc />
      ) : userInfo.accessMode === process.env.REACT_APP_SUPORTE_SINCRONIZA_ACCESS ? (
        <SuporteSinc />
      ) : userInfo.accessMode === process.env.REACT_APP_USER_SPA_ACCESS ? (
        <UserSpa />
      ) : userInfo.accessMode === process.env.REACT_APP_ADMIN_SPA_ACCESS ? (
        <AdminSpa />
      ) : userInfo.accessMode === process.env.REACT_APP_ACCESSKEY_NEW_SYSTEM ? (
        <NewSystem />
      ) : (
        <h1>Sem menu</h1>
      )}
    </ContainerMenu>
  );
}
